<template>
    <div v-if="!this.$isEmpty(company)" class="selectedcompany">
        <v-layout row class="detailfieldinfo">
             <v-flex xs4>
                  <v-label>{{$t('Company.SelectCompany.COMPANY_NAME_FIELD_NAME')}} :</v-label>
             </v-flex>
              <v-flex xs8>
                  <v-label>{{company.name}}</v-label>
             </v-flex>
        </v-layout>
         <v-layout v-if="company.mainIdentifierCode !== ''" row class="detailfieldinfo">
             <v-flex xs4>
                  <v-label>{{company.mainIdentifierCode}} :</v-label>
             </v-flex>
              <v-flex xs8>
                  <v-label>{{company.mainIdentifierValue}}</v-label>
             </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo">
             <v-flex xs4>
                  <v-label>{{$t('Company.SelectCompany.COUNTRY_FIELD_NAME')}} :</v-label>
             </v-flex>
              <v-flex xs8>
                  <v-label>{{company.country}}</v-label>
             </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo">
             <v-flex xs4>
                  <v-label>{{$t('Company.SelectCompany.ADDRESS_FIELD_NAME')}} :</v-label>
             </v-flex>
              <v-flex xs8>
                  <v-label>{{company.streetNumber}} {{company.streetName}} {{company.postCode}} {{company.city}}</v-label>
             </v-flex>
        </v-layout>
    </div>
</template>
<script>
export default {
  props: ['company']
}
</script>
<style scoped>
.selectedcompany {
    width: 100%;
}

</style>
